import React from 'react';
import '/Users/jilin/projects/antd/rc-dialog/docs/index.md?watch=parent';
export const demos = {
};